import { T } from "../../../app/tokens.js";

export const btn = {
  border: `1px solid ${T.border}`, background: T.card, color: T.dark,
  borderRadius: 6, padding: "4px 10px", fontSize: T.fsXs, fontWeight: T.fwSemibold,
  cursor: "pointer", whiteSpace: "nowrap",
};
export const btnPrimary = { ...btn, background: T.blue, color: T.white, border: `1px solid ${T.blue}` };
export const btnMeeting = { ...btn, background: T.ragAmberBg, color: T.ragAmberText, border: `1px solid ${T.ragAmberBorder}` };
export const btnDisabled = { opacity: 0.45, cursor: "not-allowed" };
export const muted = { color: T.mid, fontSize: T.fsXs };
export const demoChip = {
  display: "inline-flex", alignItems: "center", border: `1px dashed ${T.border}`, borderRadius: 4,
  padding: "1px 6px", fontSize: T.fsXxs, fontWeight: T.fwSemibold, color: T.mid, whiteSpace: "nowrap",
};
export const inputStyle = {
  width: "100%", fontSize: T.fsSm, padding: "6px 8px", borderRadius: 6,
  border: `1px solid ${T.border}`, fontFamily: "inherit", boxSizing: "border-box", lineHeight: 1.45,
};

export function withDisabled(style, disabled) {
  return disabled ? { ...style, ...btnDisabled } : style;
}
